import { IContentParams } from '../../schemas/schema';

export class ContentStack {
  getRequestPayload(contentParams?: IContentParams) {
    return {
      query: {
        getUserHelpContent: {
          menuItems: {
            dataTypes: {
              fieldName: true,
              fieldType: true,
              schema: {
                fieldName: true,
                fieldType: true,
                schema: {
                  fieldName: true,
                  fieldType: true
                }
              }
            },
            title: true,
            group: {
              menuItem: true,
              menuSequence: true,
              uid: true
            }
          },
          menuEntries: {
            dataTypes: {
              fieldName: true,
              fieldType: true,
              schema: {
                fieldName: true,
                fieldType: true,
                schema: {
                  fieldName: true,
                  fieldType: true
                }
              }
            },
            uid: true,
            sections: {
              title: true,
              richTextDescription: true,
              group: {
                title: true,
                description: true,
                richTextDescription: true,
                video: {
                  title: true,
                  href: true
                }
              }
            },
            group: {
              title: true,
              description: true,
              richTextDescription: true,
              video: {
                title: true,
                href: true
              }
            },
            tags: true,
            richText: true
          }
        }
      }
    };
  }
}
